import { render, staticRenderFns } from "./UkRegistration.vue?vue&type=template&id=fddd935c"
import script from "./UkRegistration.vue?vue&type=script&lang=js"
export * from "./UkRegistration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports